import { c as _c } from "react/compiler-runtime";
import type { AuditEvent, AuditEventDetail } from '@onefootprint/request-types/dashboard';
import DecryptionReason from './decryption-reason';
type EventBodyProps = {
  auditEvent: AuditEvent;
  showDecryptionReason: boolean;
};
const EventBody = t0 => {
  const $ = _c(2);
  const {
    auditEvent,
    showDecryptionReason
  } = t0;
  const {
    detail
  } = auditEvent;
  const {
    kind
  } = detail;
  if (!showDecryptionReason) {
    return null;
  }
  if (kind === "decrypt_user_data") {
    const t1 = detail as AuditEventDetail;
    let t2;
    if ($[0] !== t1) {
      t2 = <DecryptionReason detail={t1} />;
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  return null;
};
export default EventBody;